export default [
  {
    id: "ambient01",
    position: { top: "39.7%", left: "2.25%" },
    width: "2.3%",
    height: "auto",
    animation: "windmill.json",
    ref: "windMillOne",
    loop: true,
    delay: 0
  },
  {
    id: "ambient02",
    position: { top: "42%", left: "5.05%" },
    width: "2.3%",
    height: "auto",
    animation: "windmill.json",
    ref: "windMillTwo",
    loop: true,
    delay: 500
  },
  {
    id: "ambient03",
    position: { top: "30.7%", left: "91.08%" },
    zIndex: -1,
    width: "8.5%",
    height: "auto",
    animation: "Smoke.json",
    ref: "smokeStack",
    loop: true,
    delay: 0
  },
  {
    id: "ambient04",
    position: { top: "41%", left: "54.62%" },
    width: "9.65%",
    height: "auto",
    animation: "train.json",
    ref: "train",
    loop: false,
    delay: 0,
    needsPause: true,
    pauseDelay: 8000
  },
  {
    id: "ambient05",
    position: { top: "54.8%", left: "0%" },
    width: "28.55%",
    height: "auto",
    animation: "ambient_cars_1.3.json",
    ref: "trafficOne",
    loop: true,
    delay: 0
  },
  {
    id: "ambient06",
    position: { top: "57.9%", left: "38.9%" },
    width: "32%",
    height: "auto",
    animation: "ambient_cars_2.json",
    ref: "trafficTwo",
    loop: true,
    delay: 0
  },
  {
    id: "ambient07",
    position: { top: "64.4%", left: "2.3%" },
    width: "10%",
    height: "auto",
    animation: "dock.json",
    ref: "dock",
    loop: true,
    delay: 0
  },
  {
    id: "ambient08",
    position: { top: "64%", left: "6.95%" },
    width: "10%",
    height: "auto",
    animation: "hovercraft.json",
    ref: "boat",
    loop: true,
    delay: 0
  },
  {
    id: "ambient09",
    position: { top: "67%", left: "53%" },
    width: "3%",
    height: "auto",
    animation: "BouyLoop.json",
    ref: "bouy",
    loop: true,
    delay: 0
  },
  {
    id: "ambient10",
    position: { top: "40.7%", left: "26.8%" },
    zIndex: -1,
    width: "7.4%",
    height: "auto",
    animation: "fountain.json",
    ref: "fountain01",
    loop: true,
    delay: 0
  },
  {
    id: "ambient11",
    position: { top: "37%", left: "81.25%" },
    zIndex: -1,
    width: "7.4%",
    height: "auto",
    animation: "fountain.json",
    ref: "fountain02",
    loop: true,
    delay: 0
  },
  {
    id: "ambient12",
    position: { top: "35.95%", left: "54.169%" },
    width: "23%",
    height: "auto",
    animation: "mall_walking_people.json",
    ref: "mallWalker",
    loop: true,
    delay: 0
  },
  {
    id: "ambient13",
    position: { top: "50.8%", left: "54%" },
    zIndex: -1,
    width: "24%",
    height: "auto",
    animation: "stadium_walking_people.json",
    ref: "StadiumWalker",
    loop: true,
    delay: 0
  }
];
